// extracted by mini-css-extract-plugin
module.exports = {"labelContent":"_c2444e4","infoPrompt":"_65d46f9"};